import { render, staticRenderFns } from "./AudioSettingTab.vue?vue&type=template&id=e1736d12&scoped=true&"
import script from "./AudioSettingTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AudioSettingTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AudioSettingTab.vue?vue&type=style&index=0&id=e1736d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1736d12",
  null
  
)

export default component.exports